import { useState, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthProvider'
import { AppRoutes } from '@/routes/AppRoutes'
import { initializeUser } from './store/userStore'
import { getCurrentUser } from '@/db/indexedDB'
import { useAppStore } from '@/store'
import { Loader } from '@/components/UI/Loader'

function App() {
  const [initialized, setInitialized] = useState(false)
  const { setUser } = useAppStore()

  useEffect(() => {
    const init = async () => {
      await initializeUser()
      const storedUser = await getCurrentUser()
      if (storedUser) setUser(storedUser)
      setInitialized(true)
    }
    init()
  }, [setUser])

  return (
    <Router>
      <AuthProvider>{initialized ? <AppRoutes /> : <Loader />}</AuthProvider>
    </Router>
  )
}

export default App
